/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Clean_TextInputs */

const en_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean Up Text`)
};

const fr_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyer le texte`)
};

const de_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text bereinigen`)
};

const it_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulisci il testo`)
};

const ru_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистка текста`)
};

const es_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar texto`)
};

const zh_cn2_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清理文本`)
};

const ja_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストのクリーンアップ`)
};

const hi_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को साफ करें`)
};

const pt_pt2_context_menu_clean_text = /** @type {(inputs: Context_Menu_Clean_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar texto`)
};

/**
* | output |
* | --- |
* | "Clean Up Text" |
*
* @param {Context_Menu_Clean_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_clean_text = /** @type {((inputs?: Context_Menu_Clean_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Clean_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_clean_text(inputs)
	if (locale === "de") return de_context_menu_clean_text(inputs)
	if (locale === "it") return it_context_menu_clean_text(inputs)
	if (locale === "ru") return ru_context_menu_clean_text(inputs)
	if (locale === "es") return es_context_menu_clean_text(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_clean_text(inputs)
	if (locale === "ja") return ja_context_menu_clean_text(inputs)
	if (locale === "hi") return hi_context_menu_clean_text(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_clean_text(inputs)
	return en_context_menu_clean_text(inputs)
});